export const WINE_LIST_REQUEST = 'WINE_LIST_REQUEST'
export const WINE_LIST_SUCCESS = 'WINE_LIST_SUCCESS'
export const WINE_LIST_FAILURE = 'WINE_LIST_FAILURE'
export const WINE_LATEST_ACTIVITY_REQUEST = 'WINE_LATEST_ACTIVITY_REQUEST'
export const WINE_LATEST_ACTIVITY_SUCCESS = 'WINE_LATEST_ACTIVITY_SUCCESS'
export const WINE_LATEST_ACTIVITY_FAILURE = 'WINE_LATEST_ACTIVITY_FAILURE'
export const GET_WINE_DATA_REQUEST = 'GET_WINE_DATA_REQUEST'
export const GET_WINE_DATA_SUCCESS = 'GET_WINE_DATA_SUCCESS'
export const GET_WINE_DATA_FAILURE = 'GET_WINE_DATA_FAILURE'
export const UPDATE_CW_WINE_NOTE_REQUEST = 'UPDATE_CW_WINE_NOTE_REQUEST'
export const UPDATE_CW_WINE_NOTE_SUCCESS = 'UPDATE_CW_WINE_NOTE_SUCCESS'
export const UPDATE_CW_WINE_NOTE_FAILURE = 'UPDATE_CW_WINE_NOTE_FAILURE'
export const CELLAR_STATS_REQUEST = 'CELLAR_STATS_REQUEST'
export const CELLAR_STATS_SUCCESS = 'CELLAR_STATS_SUCCESS'
export const CELLAR_STATS_FAILURE = 'CELLAR_STATS_FAILURE'
export const WINE_RESERVATION_REQUEST = 'WINE_RESERVATION_REQUEST'
export const WINE_RESERVATION_SUCCESS = 'WINE_RESERVATION_SUCCESS'
export const WINE_RESERVATION_FAILURE = 'WINE_RESERVATION_FAILURE'
export const UPDATE_WINE_INFO_REQUEST = 'UPDATE_WINE_INFO_REQUEST'
export const UPDATE_WINE_INFO_SUCCESS = 'UPDATE_WINE_INFO_SUCCESS'
export const UPDATE_WINE_INFO_FAILURE = 'UPDATE_WINE_INFO_FAILURE'
export const CLEAN_WINE_RESERVATION_STATUS = 'CLEAN_WINE_RESERVATION_STATUS'

export const wineListReq = payload => ({
    type: WINE_LIST_REQUEST,
    payload
})

export const wineListSuccess = payload => ({
    type: WINE_LIST_SUCCESS,
    payload
})

export const wineListFailure = payload => ({
    type: WINE_LIST_FAILURE,
    payload
})

export const wineLatestActivityReq = payload => ({
    type: WINE_LATEST_ACTIVITY_REQUEST,
    payload
})

export const wineLatestActivitySuccess = payload => ({
    type: WINE_LATEST_ACTIVITY_SUCCESS,
    payload
})

export const wineLatestActivityFailure = payload => ({
    type: WINE_LATEST_ACTIVITY_FAILURE,
    payload
})

export const getWineDataReq = payload => ({
    type: GET_WINE_DATA_REQUEST,
    payload
})

export const getWineDataSuccess = payload => ({
    type: GET_WINE_DATA_SUCCESS,
    payload
})

export const getWineDataFailure = payload => ({
    type: GET_WINE_DATA_FAILURE,
    payload
})

export const updateCwWineNoteReq = payload => ({
    type: UPDATE_CW_WINE_NOTE_REQUEST,
    payload
})

export const updateCwWineNoteSuccess = payload => ({
    type: UPDATE_CW_WINE_NOTE_SUCCESS,
    payload
})

export const updateCwWineNoteFailure = payload => ({
    type: UPDATE_CW_WINE_NOTE_FAILURE,
    payload
})

export const cellarStatsReq = payload => ({
    type: CELLAR_STATS_REQUEST,
    payload
})

export const cellarStatsSuccess = payload => ({
    type: CELLAR_STATS_SUCCESS,
    payload
})

export const cellarStatsFailure = payload => ({
    type: CELLAR_STATS_FAILURE,
    payload
})

export const wineReservationReq = payload => ({
    type: WINE_RESERVATION_REQUEST,
    payload
})

export const wineReservationSuccess = payload => ({
    type: WINE_RESERVATION_SUCCESS,
    payload
})

export const wineReservationFailure = payload => ({
    type: WINE_RESERVATION_FAILURE,
    payload
})

export const cleanWineReservationStatus = () => ({
    type: CLEAN_WINE_RESERVATION_STATUS,
})

export const updateWineInfoReq = payload => ({
    type: UPDATE_WINE_INFO_REQUEST,
    payload
})

export const updateWineInfoSuccess = payload => ({
    type: UPDATE_WINE_INFO_SUCCESS,
    payload
})

export const updateWineInfoFailure = payload => ({
    type: UPDATE_WINE_INFO_FAILURE,
    payload
})